import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import {
    PurchaseAdviceAddEdit, PurchaseAdviceListing, SuppliersAdd, ApproveSupplierAddEdit,
    WeighmentVerification, OrderCompletion, ViewWeightment, ViewOrdersAddEdit
} from './Pages'

export const PurchaseAdviceRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={PurchaseAdviceListing} />
        <Route exact path={`${match.path}/AddEdit/:id?`} component={PurchaseAdviceAddEdit} />
        <Route exact path={`${match.path}/AddSupplier/:id?`} component={SuppliersAdd} />
        <Route exact path={`${match.path}/approveSuppliers/:id?`} component={ApproveSupplierAddEdit} />
        <Route exact path={`${match.path}/weighmentVerification/:id?`} component={WeighmentVerification} />
        <Route exact path={`${match.path}/weighmentVerification/viewWieghment/:id?`} component={ViewWeightment} />
        <Route exact path={`${match.path}/orderCompletion/viewWieghment/:id?`} component={ViewWeightment} />
        <Route exact path={`${match.path}/AddEdit/viewWieghment/:id?`} component={ViewWeightment} />
        <Route exact path={`${match.path}/orderCompletion/:id?`} component={OrderCompletion} />
        <Route exact path={`${match.path}/viewOrder/:id?`} component={ViewOrdersAddEdit} />
        <Route exact path={`${match.path}/viewOrder/viewWieghment/:id?`} component={ViewWeightment} />
    </Fragment>
)